import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "text-center mb-8 px-10" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "font-normal text-grey-800 text-center pb-5" }
const _hoisted_6 = {
  key: 0,
  class: "mt-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "font-bold text-center my-6" }, [
        _createTextVNode(" Félicitation votre compte "),
        _createElementVNode("br"),
        _createElementVNode("span", { class: "text-3xl text-primary-color" }, "COOP FINANCE"),
        _createTextVNode(" a été créé ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.statusImage,
          class: "auth-logo",
          alt: "Statut de création de compte"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.statusMessage), 1),
      (_ctx.showActions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args))),
              class: "btn lg w-100 flex-center mb-4"
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: "/public/icons/icon-valider.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Se connecter", -1)
            ]))])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}